export const STORAGE_KEYS = {
  USER: "user",
  TOKEN: "token",
  TENANT: "t",
  USER_DATA: "userData",
  CHECKOUT_CONTEXT: "chkctx",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
